export default __webpack_public_path__ + "static/media/bridgelandscape.cd8aa870.jpg";